module.exports = __webpack_public_path__ + "static/media/rundt.4515b1df.mp3";